import { Icon } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledIcon = styled(Icon)<{
  $isDisabled: boolean;
  $enableHover: boolean;
}>`
  ${({ $enableHover }) =>
    $enableHover &&
    css`
      &:hover {
        transform: scale(1.25);
        cursor: pointer !important;
      }
    `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      > path {
        fill: var(--surface-default);
        stroke: var(--icon-disabled);
      }
    `}
`;
